const styles = {
  ratingArea: {
    padding: '16px',
    paddingLef: '24px',
  },
  areaHeader: {
    borderTop: '1px solid #e6e6e6',
    paddingBottom: '0px!important',
    paddingTop: '15px!important',
  },
  starWrapper: { maxWidth: '20px' },
  title: { fontWeight: 500 },
  percentage: {
    backgroundColor: '#e9e9e9',
    '& > div': {
      backgroundColor: '#383838',
      height: '2px',
    },
  },
  value: {
    paddingLeft: '10px',
    fontWeight: 600,
  },
  commentWrapper: {
    '@media (max-width:430px)': {
      flexDirection: 'column',
      height: '210px',
      width: '600px',
      overflow: 'scroll',
    },
  },
  wrapper: {
    marginTop: '10px',
    marginBottom: '10px',
    '@media (max-width:430px)': {
      border: '1px solid #b3b3b3',
      borderRadius: '12px',
      height: '185px',
      width: '230px',
      padding: '12px',
      marginRight: '10px',
    },
  },
  showAllcomments: {
    display: 'none',
    '@media (max-width:430px)': {
      display: 'block',
      textAlign: 'center',
      padding: '60px',
      userSelect: 'none',
    },
  },
  text: {
    fontWeight: 600,
    fontSize: '12px',
    height: '20px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
  },
  comments: {
    fontSize: '14px',
    height: '65px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    marginTop: '10px',
    '@media (min-width:430px)': {
      marginRight: '20px',
    },
    '@media (max-width:430px)': {
      marginTop: '0px',
    },
  },
  more: {
    paddingTop: '3px',
    fontWeight: 600,
    textDecoration: 'underline',
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: '12px',
  },
};

export default styles;
